export default "__VITE_ASSET__DiU59Ei7__"